import {Component, EventEmitter, OnInit, ViewChild} from '@angular/core';
import {AbstractControl, FormControl, FormGroup, Validators} from '@angular/forms';

import {TranslateService} from '@ngx-translate/core';

import {DialogService} from '../../../dialog/dialog.service';
import {AlertService} from '@widgets/alert/alert.service';
import {BaseFillDataFormComponent} from '@widgets/form-section/base-fill-data-form-component';
import {PhoneInterviewQuestionnaireModel} from './phone-interview-questionnaire.model';
import {DictModel} from '../../../dictionary/dict.model';
import {PhoneInterviewQuestionnaireCompetenceRateModel} from './phone-interview-questionnaire-competence-rate.model';
import {SalaryModel} from '../salary.model';
import {WorkTime} from '../../../enums/work-time.enum';
import {PhoneInterviewQuestionnaireLocationModel} from './phone-interview-questionnaire-location.model';
import {PhoneInterviewService} from '@core/ecv-http-services/services/phone-interview.service';
import {DictService} from '@core/ecv-http-services/services/dict.service';
import {ValidatorService} from '@core/validator/validator.service';
import {CustomValidators} from '@core/validator/custom-validators';
import {JobOrderService} from '@core/ecv-http-services/services/job-order.service';
import {EcvLanguageService} from '@core/ecv-language.service';
import {LabelListComponent} from '@widgets/form-section/label-list/label-list.component';
import {DictEnum} from '../../../enums/dict.enum';
import {NgRedux} from 'ng2-redux';
import {IAppState} from '../../../store';
import {ActivatedRoute} from '@angular/router';
import {Location} from '@angular/common';
import {SEARCHED_REF_NUMBER} from '../../../actions';
import {Ng4LoadingSpinnerService} from 'ng4-loading-spinner';
import {PhoneInterviewStatus} from '../../../enums/phone-interview-status.enum';
import {PhoneInterviewQuestionnaireHistoryComponent} from './history/phone-interview-questionnaire-history.component';
import {EmploymentForm} from '../../../enums/employment-form.enum';
import {NoticePeriodEnum} from '../../../enums/notice-period.enum';
import SalaryUtils from '../../salary-utils';
import {JoinedInterviewModel} from '../joined-interview.model';
import {JoinedInterviewsService} from '@core/ecv-http-services/services/joined-interviews.service';

@Component({
  selector: 'app-phone-interview-questionnaire',
  templateUrl: './phone-interview-questionnaire.component.html',
  styleUrls: ['./phone-interview-questionnaire.component.css'],
  entryComponents: [PhoneInterviewQuestionnaireHistoryComponent]
})
export class PhoneInterviewQuestionnaireComponent extends BaseFillDataFormComponent implements OnInit {

  private static JobOrderRequiredSkillDefaultGrade = 0;

  @ViewChild('skillSelector') skillSelector: LabelListComponent;

  DictEnum = DictEnum;
  questionnaireDataForm: FormGroup;
  historyQuestionnaireDataForm: FormGroup;
  questionnaireModel: PhoneInterviewQuestionnaireModel;
  questionnaires: PhoneInterviewQuestionnaireModel[];
  allInterviews: JoinedInterviewModel[];
  refNumber: string;
  showHistory = false;
  competencesDict: DictModel[] = [];
  currentPosition: number;
  positionsDict: DictModel[] = [];
  citiesDict: DictModel[] = [];
  currentCompetenceRate: PhoneInterviewQuestionnaireCompetenceRateModel;
  competences: number[] = [];
  Array = Array;
  currentSalaryModel: SalaryModel;
  expectedSalaryModel: SalaryModel;
  showEmptyCompetenceRateError = false;
  showNoCompetenceRatesError = false;
  showEmptyOfferRatingError = false;
  showNoExpectedEmploymentFormError = false;
  employmentForms: EmploymentForm[];
  noticePeriodTypes: NoticePeriodEnum[];
  workTimes: WorkTime[];
  currentLocation: PhoneInterviewQuestionnaireLocationModel;
  pendingDict: number[] = [];
  private newDictPopupOnCloseEventEmitter = new EventEmitter();
  phoneInterviewStatusType: DictModel[] = [];
  netPerHour = 0;
  netPerHourMax = 0;
  isGrayedOut = true;
  noOfferRating = false;

  constructor(private phoneInterviewService: PhoneInterviewService,
              private dictService: DictService,
              private dialogService: DialogService,
              private validatorService: ValidatorService,
              private translateService: TranslateService,
              private alertService: AlertService,
              private langService: EcvLanguageService,
              private jobOrderService: JobOrderService,
              private route: ActivatedRoute,
              private location: Location,
              private ngRedux: NgRedux<IAppState>,
              private spinnerService: Ng4LoadingSpinnerService,
              private joinedInterviewsService: JoinedInterviewsService) {
    super();
    this.showHistory = false;
    this.clearAll();
  }

  ngOnInit() {
    this.createForm();
    this.createHistoryForm();
    this.initializeWorkTimes();
    this.initializeEmploymentForms();
    this.initializeNoticeTypes();
    this.initializeStatusTypes();
    this.newDictPopupOnCloseEventEmitter.subscribe(event => {
      this.skillSelector.focus();
    });
    this.prefillRefNumber();
  }

  onSave() {
    this.showNoCompetenceRatesError = this.questionnaireModel.competenceRates.length === 0;
    this.showEmptyOfferRatingError = !this.questionnaireModel.offerRating;
    this.showNoExpectedEmploymentFormError = this.questionnaireModel.expectedEmploymentForm === null
      || this.questionnaireModel.expectedEmploymentForm === undefined;

    this.questionnaireModel.competenceRates
      .filter(rate => rate.yearsOfExperience)
      .map(rate => rate.yearsOfExperience = parseFloat(rate.yearsOfExperience.toString().replace(',', '.')));
    this.questionnaireModel.referenceNumber = this.questionnaireModel.referenceNumber ?
      this.questionnaireModel.referenceNumber.trim() : null;
    this.questionnaireModel.jobOrderNumber = this.questionnaireModel.jobOrderNumber ?
      this.questionnaireModel.jobOrderNumber.trim() : null;
    this.questionnaireModel.jobOrderDescription = this.questionnaireModel.jobOrderDescription ?
      this.questionnaireModel.jobOrderDescription.trim() : null;
    this.questionnaireModel.jobOrderClient = this.questionnaireModel.jobOrderClient ?
      this.questionnaireModel.jobOrderClient.trim() : null;
    this.questionnaireModel.candidateRating = this.questionnaireModel.candidateRating ?
      this.questionnaireModel.candidateRating.trim() : null;
    this.questionnaireModel.currentProjectAdvantages = this.questionnaireModel.currentProjectAdvantages ?
      this.questionnaireModel.currentProjectAdvantages.trim() : null;
    this.questionnaireModel.currentProjectDisadvantages = this.questionnaireModel.currentProjectDisadvantages ?
      this.questionnaireModel.currentProjectDisadvantages.trim() : null;
    this.questionnaireModel.selfDevelopmentDirection = this.questionnaireModel.selfDevelopmentDirection ?
      this.questionnaireModel.selfDevelopmentDirection.trim() : null;
    this.questionnaireModel.otherRecruitments = this.questionnaireModel.otherRecruitments ?
      this.questionnaireModel.otherRecruitments.trim() : null;
    this.questionnaireModel.comments = this.questionnaireModel.comments ?
      this.questionnaireModel.comments.trim() : null;

    this.validatorService.validate(this.questionnaireDataForm);
    if (!this.validatorService.isValid(this.questionnaireDataForm) || this.showNoCompetenceRatesError
      || (this.showEmptyOfferRatingError && !this.noOfferRating) || this.showNoExpectedEmploymentFormError) {
      this.showSaveAlert(false);
      return;
    }

    if (this.currentSalaryModel.salary) {
      this.questionnaireModel.currentSalary = this.currentSalaryModel.salary ? parseFloat(this.currentSalaryModel.salary.toString()
        .replace(',', '.')) : undefined;
      this.questionnaireModel.currentSalaryType = this.currentSalaryModel.salary ? this.currentSalaryModel.salaryType : undefined;
      this.questionnaireModel.currentSalaryMode = this.currentSalaryModel.salary ? this.currentSalaryModel.salaryMode : undefined;
    }
    this.questionnaireModel.expectedSalary = this.expectedSalaryModel.salary ? parseFloat(this.expectedSalaryModel.salary.toString()
      .replace(',', '.')) : undefined;
    this.questionnaireModel.expectedSalaryMax = this.expectedSalaryModel.salaryMax ? parseFloat(this.expectedSalaryModel.salaryMax.toString()
      .replace(',', '.')) : undefined;
    this.questionnaireModel.expectedSalaryType = this.expectedSalaryModel.salary ? this.expectedSalaryModel.salaryType : undefined;
    this.questionnaireModel.expectedSalaryMode = this.expectedSalaryModel.salary ? this.expectedSalaryModel.salaryMode : undefined;

    if (this.questionnaireModel.expectedSalary > this.questionnaireModel.expectedSalaryMax) {
      this.showSaveAlert(false);
      return;
    }

    this.phoneInterviewService.createQuestionnaire(this.questionnaireModel).subscribe(
      response => {
        this.ngRedux.dispatch({type: SEARCHED_REF_NUMBER, value: this.questionnaireModel.referenceNumber});
        if (this.refNumber === this.questionnaireModel.referenceNumber && this.allInterviews) {
          let interview = response as JoinedInterviewModel;
          interview.interviewType = 'PHONE_INTERVIEW';
          this.allInterviews.unshift(interview);
        } else {
          this.refNumber = this.questionnaireModel.referenceNumber;
          this.getAllQuestionnaires();
        }
        this.clearAll();
        this.createForm();
        this.showSaveAlert(true);
      });
  }

  onChangeHistoryVisibility() {
    this.showHistory = !this.showHistory;
  }

  searchForExpertsQuestionnaires() {
    this.validatorService.validate(this.historyQuestionnaireDataForm);
    if (!this.validatorService.isValid(this.historyQuestionnaireDataForm)) {
      return;
    }
    this.getAllQuestionnaires();
  }

  addCompetence() {
    this.validatorService.validateControl(<FormControl>this.questionnaireDataForm.get('competence-id'));
    this.validatorService.validateControl(<FormControl>this.questionnaireDataForm.get('yearsOfExperience'));
    if (!this.questionnaireDataForm.get('competence-id').valid) {
      return;
    }
    if (!this.questionnaireDataForm.get('yearsOfExperience').valid) {
      return;
    }
    if (!this.currentCompetenceRate.competenceDictId || this.currentCompetenceRate.yearsOfExperience === undefined
      || this.currentCompetenceRate.yearsOfExperience.toString() === '') {
      this.showEmptyCompetenceRateError = true;
      return;
    }
    this.currentCompetenceRate.competenceRate = PhoneInterviewQuestionnaireComponent.JobOrderRequiredSkillDefaultGrade;
    if (!this.questionnaireModel.competenceRates
      .find(cr => cr.competenceDictId === this.currentCompetenceRate.competenceDictId)) {
      if (this.currentCompetenceRate.yearsOfExperience) {
        this.currentCompetenceRate.yearsOfExperience = parseFloat(this.currentCompetenceRate.yearsOfExperience
          .toString().replace(',', '.'));
      }
      this.questionnaireModel.competenceRates.unshift(this.currentCompetenceRate);
      this.dictService.getDictionary(this.currentCompetenceRate.competenceDictId).subscribe(
        response => this.competencesDict.unshift(<DictModel>response)
      );
      this.showEmptyCompetenceRateError = false;
      this.showNoCompetenceRatesError = false;
      this.clearCurrentCompetenceRate();
    }
  }

  removeCompetence(index: number) {
    this.questionnaireModel.competenceRates.splice(index, 1);
  }

  getCompetenceName(id: number): string {
    if (!id) {
      return '';
    }
    const foundCompetences = this.competencesDict.filter(x => x.id === id);
    if (!foundCompetences || foundCompetences.length === 0) {
      if (this.pendingDict.find(x => x === id)) {
        return '';
      }
      this.pendingDict.push(id);
      this.dictService.getDictionary(id).subscribe(response => {
        if (!this.competencesDict.find(x => x.id === id)) {
          this.competencesDict.push(response);
        }
      });
      return '';
    }

    return this.langService.pickFromDictionary(foundCompetences[0]);

  }

  getPositionName(id: number): string {
    if (!id) {
      return '';
    }
    const foundPositions = this.positionsDict.filter(x => x.id === id);
    if (!foundPositions || foundPositions.length === 0) {
      return '';
    }

    return this.langService.pickFromDictionary(foundPositions[0]);

  }

  addLocation() {
    this.validatorService.validateControl(<FormControl>this.questionnaireDataForm.get('locationCity-id'));
    this.validatorService.validateControl(<FormControl>this.questionnaireDataForm.get('locationDistrictName'));
    if (!this.questionnaireDataForm.get('locationCity-id').valid) {
      return;
    }
    if (!this.questionnaireDataForm.get('locationDistrictName').valid) {
      return;
    }
    if (!this.currentLocation.cityDictId) {
      return;
    }
    if (!this.questionnaireModel.locations
      .find(cr => cr.cityDictId === this.currentLocation.cityDictId
        && cr.districtName === this.currentLocation.districtName)) {
      this.questionnaireModel.locations.unshift(this.currentLocation);
      this.dictService.getDictionary(this.currentLocation.cityDictId).subscribe(
        response => this.citiesDict.unshift(<DictModel>response)
      );
      this.clearCurrentLocation();
    }
  }

  removeCityLocation(index: number) {
    this.questionnaireModel.locations.splice(index, 1);
  }

  getCityName(id: number): string {
    if (!id) {
      return '';
    }
    const foundCities = this.citiesDict.filter(x => x.id === id);
    if (!foundCities || foundCities.length === 0) {
      return '';
    }

    return this.langService.pickFromDictionary(foundCities[0]);

  }

  addPosition() {
    this.validatorService.validateControl(<FormControl>this.questionnaireDataForm.get('desiredPosition-id'));
    if (!this.questionnaireDataForm.get('desiredPosition-id').valid) {
      return;
    }
    if (!this.currentPosition) {
      return;
    }
    if (!this.questionnaireModel.desiredPositionsDictId
      .find(p => p === this.currentPosition)) {
      this.questionnaireModel.desiredPositionsDictId.unshift(this.currentPosition);
      this.dictService.getDictionary(this.currentPosition).subscribe(
        response => this.positionsDict.unshift(<DictModel>response)
      );
      this.clearCurrentPosition();
    }
  }

  removePosition(index: number) {
    this.questionnaireModel.desiredPositionsDictId.splice(index, 1);
  }

  openModal(title: string, dictType: number, control: AbstractControl, maxLength: number, data: any,
            property: string) {
    this.dialogService.open(title, dictType, control, maxLength, data, property, this.newDictPopupOnCloseEventEmitter);
    this.newDictPopupOnCloseEventEmitter.subscribe((element) => {
      switch (property) {
        case 'competenceDictId':
          this.questionnaireDataForm.controls['competence-id'].setValue(element.id);
          break;
        case 'currentJobCity':
          this.questionnaireDataForm.controls['currentJobCity-id'].setValue(element.id);
          break;
        case 'desiredPosition':
          this.questionnaireDataForm.controls['desiredPosition-id'].setValue(element.id);
          break;
        case 'locationCity':
          this.questionnaireDataForm.controls['locationCity-id'].setValue(element.id);
          break;
      }
    });
  }

  onLoadJobOrderSkillsButtonPressed() {
    this.questionnaireModel.competenceRates = [];
    if (!this.questionnaireDataForm.get('jobOrderNumber').valid) {
      return;
    }
    this.spinnerService.show();
    this.jobOrderService.getJobOrderSkills(this.questionnaireModel.jobOrderNumber).subscribe(
      response => {
        const res: DictModel[] = response;
        for (let i = 0; i < res.length; i++) {
          this.addCompetenceRate(res[i], PhoneInterviewQuestionnaireComponent.JobOrderRequiredSkillDefaultGrade);
        }
        this.showNoCompetenceRatesError = false;
        this.showEmptyCompetenceRateError = false;
        this.clearCurrentCompetenceRate();
        this.spinnerService.hide();
      }, requestError => {
        this.spinnerService.hide();
      }
    );
  }

  private addCompetenceRate(dict: DictModel, grade: number) {
    // check if already exists
    for (let i = 0; i < this.questionnaireModel.competenceRates.length; i++) {
      if (this.questionnaireModel.competenceRates[i].competenceDictId === dict.id) {
        return;
      }
    }
    const rate = new PhoneInterviewQuestionnaireCompetenceRateModel();
    rate.competenceRate = grade;
    rate.competenceDictId = dict.id;
    this.questionnaireModel.competenceRates.unshift(rate);
    this.competencesDict.unshift(dict);
  }

  private showSaveAlert(valid: boolean) {
    if (valid) {
      this.translateService.get('ALERT.RPM_INTERVIEW_SAVED', {}).subscribe((res: string) => {
        this.alertService.success(res);
      });
    } else {
      this.translateService.get('ALERT.FIX_ERRORS', {}).subscribe((res: string) => {
        this.alertService.error(res);
      });
    }
  }

  private initializeWorkTimes() {
    this.workTimes = [];
    for (const n in WorkTime) {
      if (typeof WorkTime[n] === 'number') {
        this.workTimes.push(WorkTime[WorkTime[n]]);
      }
    }
  }

  private initializeEmploymentForms() {
    this.employmentForms = [];
    for (const n in EmploymentForm) {
      if (typeof EmploymentForm[n] === 'number') {
        this.employmentForms.push(EmploymentForm[EmploymentForm[n]]);
      }
    }
  }

  private initializeNoticeTypes() {
    this.noticePeriodTypes = [];
    for (const n in NoticePeriodEnum) {
      if (typeof NoticePeriodEnum[n] === 'number') {
        this.noticePeriodTypes.push(NoticePeriodEnum[NoticePeriodEnum[n]]);
      }
    }
  }

  private initializeStatusTypes() {
    for (const n in PhoneInterviewStatus) {
      if (typeof PhoneInterviewStatus[n] === 'number') {
        this.phoneInterviewStatusType.push(PhoneInterviewStatus[PhoneInterviewStatus[n]]);
      }
    }
  }

  private clearAll() {
    this.questionnaireModel = new PhoneInterviewQuestionnaireModel();
    this.currentSalaryModel = new SalaryModel();
    this.expectedSalaryModel = new SalaryModel();
    this.currentSalaryModel.salaryType = 0;
    this.currentSalaryModel.salaryMode = 1;
    this.expectedSalaryModel.salaryType = 0;
    this.expectedSalaryModel.salaryMode = 1;
    this.questionnaireModel.currentEmploymentForm = null;
    this.questionnaireModel.expectedEmploymentForm = null;
    this.questionnaireModel.workTime = 0;
    this.questionnaireModel.remoteWork = false;
    this.noOfferRating = false;
    this.showEmptyOfferRatingError = false;
    this.clearCurrentCompetenceRate();
    this.clearCurrentLocation();
    this.clearCurrentPosition();
  }

  private clearCurrentCompetenceRate() {
    this.currentCompetenceRate = new PhoneInterviewQuestionnaireCompetenceRateModel();
  }

  private clearCurrentLocation() {
    this.currentLocation = new PhoneInterviewQuestionnaireLocationModel();
  }

  private clearCurrentPosition() {
    this.currentPosition = undefined;
  }

  private createForm() {
    this.questionnaireDataForm = new FormGroup({
      'referenceNumber': new FormControl('', [CustomValidators.notEmpty, CustomValidators.validateReferenceNumber()]),
      'jobOrderNumber': new FormControl('', [CustomValidators.notEmpty, CustomValidators.validateJobOrderNumber]),
      'currentSalary': new FormControl('', [Validators.max(1000000), Validators.min(0),
        CustomValidators.validateDecimal]),
      'expectedSalary': new FormControl('', [Validators.required,
        Validators.max(1000000), Validators.min(0), CustomValidators.validateDecimal]),
      'expectedSalaryMax': new FormControl('', [
        Validators.max(1000000), Validators.min(0), CustomValidators.validateDecimal]),
      'remoteWork': new FormControl(''),
      'workTime': new FormControl(''),
      'desiredPosition': new FormControl(''),
      'desiredPosition-id': new FormControl('', CustomValidators.validateCorrectDictIfSet),
      'offerRating': new FormControl(''),
      'candidateRating': new FormControl(''),
      'competence': new FormControl(''),
      'competence-id': new FormControl(true, CustomValidators.validateCorrectDict),
      'competenceRate': new FormControl(''),
      'yearsOfExperience': new FormControl('', [Validators.max(100), Validators.min(0),
        CustomValidators.validateYears]),
      'currentProjectAdvantages': new FormControl(''),
      'currentProjectDisadvantages': new FormControl(''),
      'selfDevelopmentDirection': new FormControl(''),
      'otherRecruitments': new FormControl(''),
      'locationCity': new FormControl(''),
      'locationCity-id': new FormControl('', CustomValidators.validateCorrectDictIfSet),
      'locationDistrictName': new FormControl(''),
      'currentJobCity': new FormControl(''),
      'currentJobCity-id': new FormControl('', CustomValidators.validateCorrectDictIfSet),
      'noticePeriod': new FormControl('', [Validators.required]),
      'comments': new FormControl(''),
      'status': new FormControl('', [CustomValidators.notEmpty]),
      'noOfferRating': new FormControl(false)
    });
  }

  private createHistoryForm() {
    this.historyQuestionnaireDataForm = new FormGroup({
      refNumberSearch: new FormControl('', [Validators.required, CustomValidators.validateReferenceNumber()])
    });
  }

  private prefillRefNumber() {
    this.route.params.subscribe(params => {
      const refNumberFromUrl = params['refNumber'];
      if (refNumberFromUrl !== undefined) {
        this.refNumber = refNumberFromUrl;
        this.questionnaireModel.referenceNumber = refNumberFromUrl;
        this.getAllQuestionnaires();
      } else {
        const lastSearchedRefNumber = this.ngRedux.getState().searchedRefNumber;
        if (lastSearchedRefNumber !== undefined) {
          this.questionnaireModel.referenceNumber = lastSearchedRefNumber;
          this.refNumber = lastSearchedRefNumber;
          this.location.go('/phone-interview/' + lastSearchedRefNumber);
          this.getAllQuestionnaires();
        }
      }
    });
  }

  private getAllQuestionnaires() {
    this.joinedInterviewsService.getAllInterviews(this.refNumber).subscribe(response => {
      this.allInterviews = response;
      this.showHistory = true;
      this.ngRedux.dispatch({type: SEARCHED_REF_NUMBER, value: this.refNumber});
    }, () => {
      this.showHistory = false;
      this.allInterviews = undefined;
      this.ngRedux.dispatch({type: SEARCHED_REF_NUMBER, value: undefined});
    });
  }


  onChooseWorkTime(index) {
    if (this.questionnaireModel.workTime === index) {
      this.questionnaireModel.workTime = null;
    } else {
      this.questionnaireModel.workTime = index;
    }
  }

  onChooseCurrentEmploymentForm(index) {
    if (this.questionnaireModel.currentEmploymentForm === index) {
      this.questionnaireModel.currentEmploymentForm = null;
    } else {
      this.questionnaireModel.currentEmploymentForm = index;
    }
  }

  onChooseExpectedEmploymentForm(index) {
    if (this.questionnaireModel.expectedEmploymentForm === index) {
      this.questionnaireModel.expectedEmploymentForm = null;
      this.isGrayedOut = true;
      this.netPerHour = 0;
      this.netPerHourMax = 0;
      this.showNoExpectedEmploymentFormError = true;
    } else {
      this.questionnaireModel.expectedEmploymentForm = index;
      this.isGrayedOut = index > 3;
      this.netPerHour = SalaryUtils.calculateNetPerHourSalary(index, this.expectedSalaryModel.salary);
      this.netPerHourMax = SalaryUtils.calculateNetPerHourSalary(index, this.expectedSalaryModel.salaryMax);
      this.showNoExpectedEmploymentFormError = false;
    }
  }

  getNetPerHourValue() {
    return SalaryUtils.countNetRateBasedOnSalaryMode(this.netPerHour, this.expectedSalaryModel.salaryMode);
  }

  getNetPerHourMaxValue() {
    return SalaryUtils.countNetRateBasedOnSalaryMode(this.netPerHourMax, this.expectedSalaryModel.salaryMode);
  }

  expectedSalaryChanged(event) {
    this.dataChanged();
    this.netPerHour = SalaryUtils.calculateNetPerHourSalary(this.questionnaireModel.expectedEmploymentForm, event);
  }

  expectedMaxSalaryChanged(event) {
    this.dataChanged();
    this.netPerHourMax = SalaryUtils.calculateNetPerHourSalary(this.questionnaireModel.expectedEmploymentForm, event);
  }

  noOfferRatingChange() {
    if (this.noOfferRating) {
      this.questionnaireModel.offerRating = 0;
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/interviews/questionnaires/phone-interview-questionnaire/phone-interview-questionnaire.component.ts